import { render, staticRenderFns } from "./SessionCard.vue?vue&type=template&id=ed76b304&scoped=true&"
import script from "./SessionCard.vue?vue&type=script&lang=ts&"
export * from "./SessionCard.vue?vue&type=script&lang=ts&"
import style0 from "./SessionCard.vue?vue&type=style&index=0&id=ed76b304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed76b304",
  null
  
)

export default component.exports